import MuiDialogContent from '@mui/material/DialogContent';
import {styled} from '@mui/material/styles';

export const DialogContent = styled(MuiDialogContent)(({theme}) => ({
   position: 'relative',
   padding: theme.spacing(2),
   whiteSpace: 'pre-wrap',
   display: 'flex',
   flexFlow: 'column',
}));
